import React from 'react';
import WhatsappFloat from '../components/WhatsappFloat';
import { Helmet } from 'react-helmet-async';

const PoliticaPrivacidade = () => (
  <>
    <Helmet>
      <title>Política de Privacidade | MicroCodie</title>
      <meta name="description" content="Saiba como a MicroCodie trata seus dados pessoais e garante sua privacidade ao usar nosso site." />
      <meta property="og:title" content="Política de Privacidade | MicroCodie" />
      <meta property="og:description" content="Saiba como a MicroCodie trata seus dados pessoais e garante sua privacidade ao usar nosso site." />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://www.microcodie.com.br/politica-privacidade" />
      <meta property="og:image" content="/logo192.png" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Política de Privacidade | MicroCodie" />
      <meta name="twitter:description" content="Saiba como a MicroCodie trata seus dados pessoais e garante sua privacidade ao usar nosso site." />
      <meta name="twitter:image" content="/logo192.png" />
      <link rel="canonical" href="https://www.microcodie.com.br/politica-privacidade" />
    </Helmet>
    <div className="container" style={{ padding: '3rem 0', maxWidth: 800, margin: '6rem auto 0 auto' }}>
      <h1>Política de Privacidade</h1>
      <p>Esta Política de Privacidade descreve como coletamos, usamos e protegemos as informações pessoais dos usuários do nosso site.</p>
      <h2>1. Coleta de Informações</h2>
      <p>Coletamos informações fornecidas voluntariamente por você, como nome, e-mail e telefone, ao preencher formulários de contato ou solicitar nossos serviços.</p>
      <h2>2. Uso das Informações</h2>
      <p>Utilizamos suas informações para responder solicitações, prestar serviços, melhorar a experiência do usuário e enviar comunicações relevantes.</p>
      <h2>3. Compartilhamento de Dados</h2>
      <p>Não compartilhamos suas informações pessoais com terceiros, exceto quando necessário para cumprir obrigações legais ou prestar nossos serviços.</p>
      <h2>4. Segurança</h2>
      <p>Adotamos medidas de segurança para proteger seus dados contra acesso não autorizado, alteração ou divulgação.</p>
      <h2>5. Direitos do Usuário</h2>
      <p>Você pode solicitar a atualização, correção ou exclusão de seus dados pessoais a qualquer momento, entrando em contato conosco.</p>
      <h2>6. Alterações nesta Política</h2>
      <p>Podemos atualizar esta Política de Privacidade periodicamente. Recomendamos que você revise esta página regularmente.</p>
      <p>Em caso de dúvidas, entre em contato pelo e-mail: contato@microcodie.com.br</p>
    </div>
    <WhatsappFloat />
  </>
);

export default PoliticaPrivacidade; 